"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptService = void 0;
var ScriptService = /** @class */ (function () {
    function ScriptService() {
        this.timeoutDefault = 20000;
    }
    ScriptService.prototype.Load = function (key, baseUrl, callbackName, apiObjectName, timeout, errorCallback) {
        if (timeout === void 0) { timeout = this.timeoutDefault; }
        if (errorCallback === void 0) { errorCallback = function () { return null; }; }
        return new Promise(function (resolve, reject) {
            var timeoutId = setTimeout(function () {
                reject(new Error('Script loading canceled by timeout'));
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                window[callbackName] = function () { return undefined; };
            }, timeout);
            window[callbackName] = function () {
                if (timeoutId !== null) {
                    clearTimeout(timeoutId);
                }
                resolve(window[apiObjectName]);
                delete window[callbackName];
            };
            var scriptElement = document.createElement('script');
            scriptElement.src = "" + baseUrl + key + "&callback=" + callbackName;
            scriptElement.onerror = errorCallback;
            document.body.appendChild(scriptElement);
        });
    };
    ScriptService.prototype.LoadBasic = function (uri) {
        return new Promise(function (resolve) {
            var tag = document.createElement('script');
            tag.src = uri;
            tag.async = true;
            tag.onload = function () {
                resolve();
            };
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        });
    };
    return ScriptService;
}());
var service = new ScriptService();
exports.ScriptService = service;
